import { observable, action, computed, makeObservable } from 'mobx';
import { isSome } from 'core/utils';
import _ from 'lodash';

class QueryModel {
	@observable embed;
	@observable fields;
	@observable item;
	@observable page;
	@observable recordsPerPage;
	@observable searchQuery;
	@observable sort;
	@observable totalRecords;

	constructor() {
		makeObservable(this);
	}

	@action
	set = response => {
		if (!isSome(response)) {
			return this.reset();
		}
		this.embed = response.embed;
		this.fields = response.fields;
		this.item = response.item;
		this.page = response.page;
		this.recordsPerPage = response.recordsPerPage;
		this.searchQuery = response.searchQuery;
		this.sort = response.sort;
		this.totalRecords = response.totalRecords;
	};

	@action
	reset = () => {
		this.embed = null;
		this.fields = null;
		this.item = null;
		this.page = null;
		this.recordsPerPage = null;
		this.searchQuery = null;
		this.sort = null;
		this.totalRecords = null;
	};
}

class BaseQueryStore {
	@observable response = new QueryModel();

	constructor() {
		makeObservable(this);
	}

	@computed
	get data() {
		return _.get(this.response, 'item') || [];
	}

	@action
	setResponse = response => {
		this.response.set(response);
	};
}

export default BaseQueryStore;
